export default {
  home: {
    title: '홈',
    aiBannerTxt: {
      title: 'AI 교육 실현하기',
      subtitle: 'AI+ 교육 디지털 역량 강화, 혁신적 개념 융합',
      description: '레이저 맞춤형 제품 및 기술 서비스에 집중, 교육기관 및 기업의 "AI+ Education" 통합 지원'
    },
    description: '당사 Vue.js 마케팅 사이트에 오신 것을 환영합니다',
    banner: {
      slide1: {
        title: 'STEAM 키트 | AI 키트 | 레이저 절단 키트',
        description:
          '당사는 가정, 교육자 및 유통사를 위해 혁신적인 STEAM 교육 솔루션과 다양한 키트를 제공하며, 3~16세 어린이를 위해 설계되었습니다.',
      },
      slide2: {
        title: '아이들의 창의력을 위해 설계된 전문 키트',
        description:
          '수업, 장비, 소프트웨어를 통합하여 프로젝트 기반 학습을 쉽게 진행',
      },
      slide3: {
        title: '미래 지향적 기술 교육',
        description:
          '실습 중심, 융합 교육으로 문제 해결과 협업 역량을 기릅니다',
      },
    },
    factory: {
      banner: {
        alt: '스마트 공장 배너',
        title: '스마트 공장 솔루션',
        description: '생산 라인 구축｜산업 센싱｜PLC 제어 및 데이터 수집',
        image: 'https://picsum.photos/seed/factory-banner/1000/600',
      },
      resourcesTitle: '교육 자료',
      resources: [
        {
          title: '프로젝트 기반 교육 자료',
          desc: '수업 PPT 및 강의안, 수업 활동 설계와 평가 제안.',
          image: 'https://picsum.photos/seed/factory-res-1/374/217',
        },
        {
          title: '현장 사례와 자료',
          desc: '컨베이어 제어, 공정 감지, 장비 연동 등의 예시와 코드 스니펫.',
          image: 'https://picsum.photos/seed/factory-res-2/374/217',
        },
        {
          title: '수업 후 확장 과제',
          desc: '확장 과제와 융합 적용 제안으로 탐구와 창작을 촉진.',
          image: 'https://picsum.photos/seed/factory-res-3/374/217',
        },
      ],
      intro: {
        title: '제품 소개',
        desc: '스마트 공장 솔루션은 생산 라인 구축과 프로그래밍 제어를 핵심으로 하며, 산업 센싱, 공정 식별, PLC/마이크로컨트롤러 제어 및 데이터 수집 등을 포함하고, 실습과 체계적 훈련을 강조합니다.',
        bg: 'https://picsum.photos/seed/factory-bg/1200/736',
      },
      course: {
        title: '연계 과정',
        desc: '생산 라인 구축, 산업 센싱, PLC 제어 및 데이터 수집 등을 주제로 프로젝트 기반 과정을 설계하여 실습과 체계적 훈련을 강조합니다.',
        image: 'https://picsum.photos/seed/factory-course/668/597',
      },
      equipments: [
        {
          title: '컨베이어 모듈',
          image: 'https://picsum.photos/seed/factory-eq-1/209/209',
        },
        {
          title: '광전 센서',
          image: 'https://picsum.photos/seed/factory-eq-2/209/209',
        },
        {
          title: 'PLC 제어 유닛',
          image: 'https://picsum.photos/seed/factory-eq-3/209/209',
        },
        {
          title: '로봇 암 모듈',
          image: 'https://picsum.photos/seed/factory-eq-4/209/209',
        },
        {
          title: '바코드 인식 모듈',
          image: 'https://picsum.photos/seed/factory-eq-5/209/209',
        },
        {
          title: '온습도 센서',
          image: 'https://picsum.photos/seed/factory-eq-6/209/209',
        },
        {
          title: '모터 드라이브 모듈',
          image: 'https://picsum.photos/seed/factory-eq-7/209/209',
        },
        {
          title: '공정 감지 모듈',
          image: 'https://picsum.photos/seed/factory-eq-8/209/209',
        },
        {
          title: '비상 정지 모듈',
          image: 'https://picsum.photos/seed/factory-eq-9/209/209',
        },
        {
          title: '데이터 수집 게이트웨이',
          image: 'https://picsum.photos/seed/factory-eq-10/209/209',
        },
      ],
    },
    solutions: {
      title: 'Zetok STEAM 교육 솔루션',
      learnMore: '자세히 보기 >',
      items: [
        {
          image: require('@/assets/home/solution1.webp'),
          title: 'Zetok 키트',
          description:
            '실습과 프로젝트 기반 학습을 통해 창의적 사고와 실천 능력을 기릅니다.',
          link: '/solutions/kits',
        },
        {
          image: require('@/assets/home/solution2.webp'),
          title: 'Good Laser 레이저 커터 & 조각기',
          description:
            '레이저 커터가 STEAM 교육에 새로운 실습 학습 경험을 제공합니다',
          link: '/solutions/laser',
        },
      ],
    },
    scenes: {
      title: '교육 현장',
      items: [
        {
          image: require('@/assets/home/education1.webp'),
          title: 'STEM 교육 솔루션',
        },
        {
          image: require('@/assets/home/education2.webp'),
          title: '메이커 스페이스 솔루션',
        },
      ],
    },
    aiBanner: {
      alt: 'AI 배너',
      image: require('@/assets/home/aibanner.png'),
    },
    kitsSection: {
      alt: 'Zetok 키트',
      title: '인공지능 키트',
      description:
        'AI 키트는 풍부한 상호작용과 실습 프로젝트를 포함하여 학생들의 과학기술에 대한 흥미와 호기심을 자극합니다.',
      image: require('@/assets/home/kitsbanner.png'),
    },
    kitsCarousel: {
      alt: '키트 캐러셀',
      title: '창의적 사고 향상',
      items: [
        { image: require('@/assets/home/kits1.png') },
        { image: require('@/assets/home/kits2.png') },
        { image: require('@/assets/home/kits3.png') },
        { image: require('@/assets/home/kits4.png') },
        { image: require('@/assets/home/kits5.png') },
        { image: require('@/assets/home/kits6.png') },
        { image: require('@/assets/home/kits7.png') },
        { image: require('@/assets/home/kits8.png') },
        { image: require('@/assets/home/kits9.png') },
      ],
    },
    products: {
      title: 'Zetok 키트와 Good Laser 레이저 커터',
      tabs: {
        kits: '키트',
        courses: '과정',
        laser: '레이저 장비',
        software: '소프트웨어',
      },
      items: {
        kits: [
          {
            image: require('@/assets/home/product1.webp'),
            title: '레이저 절단 입문 키트',
            description: '(전용 목재 소모품 포함)',
          },
          {
            image: require('@/assets/home/product2.webp'),
            title: '신기한 과학 상자',
            description: '(목재 + 마이크로회로 키트 패키지 포함)',
          },
          {
            image: require('@/assets/home/product3.webp'),
            title: '인공지능 프로그래밍 키트',
            description: '',
          },
        ],
        courses: [
          {
            image: require('@/assets/home/product4.webp'),
            title: '과학 탐구 체계 - 유아',
            description: '(6강)',
          },
          {
            image: require('@/assets/home/product5.webp'),
            title: 'STEAM 메이커 체계 - 청소년',
            description: '(3강)',
          },
          {
            image: require('@/assets/home/product6.webp'),
            title: '레이저 절단 과정',
            description: '(3강)',
          },
          {
            image: require('@/assets/home/product7.webp'),
            title: '인공지능 과정 체계',
            description: '(4강)',
          },
        ],
        laser: [
          {
            image: require('@/assets/home/product8.png'),
            title: 'Light 530 ',
            description: '55W 데스크톱 CO2 레이저 커터 & 조각기',
          },
          {
            image: require('@/assets/home/product9.png'),
            title: 'Light 640',
            description: '전문용 데스크톱 레이저 커터 & 조각기',
          },
          {
            image: require('@/assets/home/product10.png'),
            title: 'Light Blue 530 ',
            description: '스마트 데스크톱 블루 레이저 커터 & 조각기',
          },
          {
            image: require('@/assets/home/product11.png'),
            title: 'Mark M20',
            description: '고정밀 레이저 마킹기',
          },
        ],
        software: [
          {
            image: require('@/assets/home/product12.png'),
            title: 'Zetok 학습 플랫폼',
            description: '',
          },
          {
            image: require('@/assets/home/product13.png'),
            title: 'Zetok 클라우드 플랫폼',
            description: '',
          },
          {
            image: require('@/assets/home/product14.png'),
            title: 'Light Maker',
            description: '',
          },
          {
            image: require('@/assets/home/product15.png'),
            title: 'mind+',
            description: '',
          },
          {
            image: require('@/assets/home/product16.png'),
            title: 'Arduino',
            description: '',
          },
        ],
      },
    },
  },
  switch_lang: 'English',
  nav: {
    products: '제품',
    smartFarm: '스마트 농장',
    smartHome: '스마트 홈',
    smartTraffic: '스마트 교통',
    smartFactory: '스마트 공장',
    laserSteam: '레이저 절단 STEAM 키트',
    dreamScience: '드림 사이언스 키트',
    course: '과정',
    device: '장비',
    education: '교육 솔루션',
    stem: 'STEM 교육 솔루션',
    maker: '메이커 스페이스 솔루션',
    software: '소프트웨어',
    service: '서비스 및 지원',
    afterSale: '튜토리얼 다운로드',
    about: '회사 소개',
    aboutUs: '회사 소개',
    dealer: '당사 딜러가 되기',
    cooperation: '제품 사용 및 교육 협력',
    news: '뉴스',
    coursesSeries: '4대 과정 시리즈',
    viewMore: '더 보기',
    store: '스토어'
  },
  globalContactForm: {
    title: '문의하기',
    subtitle:
      '문의나 요청이 있으시면 언제든 연락 주세요. 성심껏 도와드리겠습니다.',
    fields: {
      name: '이름',
      email: '이메일',
      phone: '전화',
      company: '회사',
      message: '메시지',
    },
    placeholders: {
      name: '이름을 입력하세요',
      email: '이메일 주소를 입력하세요',
      phone: '연락처를 입력하세요',
      company: '회사명을 입력하세요',
      message: '요청 사항이나 질문을 작성하세요',
    },
    validation: {
      name: '이름을 입력하세요',
      email: '이메일 주소를 입력하세요',
      emailFormat: '이메일 형식이 올바르지 않습니다',
      phone: '연락처를 입력하세요',
      message: '메시지를 작성하세요',
    },
    submit: '제출',
    submitting: '제출 중…',
    visual: {
      title: '전문 서비스',
      description:
        '3~16세 아동의 과학기술 창의력 교육에 집중하며, 메이커 공간을 운영하고 관련 제품과 과정을 개발합니다.',
    },
    contact: {
      phone: '고객센터',
      email: '이메일 주소',
    },
  },
  thankYou: {
    metaTitle: '제출해 주셔서 감사합니다',
    title: '제출해 주셔서 감사합니다!',
    description: '귀하의 정보를 받아 확인했으며, 곧 연락드리겠습니다.',
    seoDescription: '제출 완료. 당사 팀이 최대한 빨리 연락드립니다.',
    backHome: '홈으로 돌아가기',
    browseProducts: '제품 계속 둘러보기',
    contactSupport: '애프터서비스 문의',
    nextStepsTitle: '이후 진행 절차',
    nextSteps: [
      '요청을 1–2 영업일 내에 검토합니다.',
      '추가 정보가 필요하면 먼저 연락드립니다.',
      '사이트를 계속 둘러보거나 전화/이메일로 문의하세요.',
    ],
    contactTitle: '즉시 도움이 필요하신가요?',
    contactPhoneLabel: '고객센터: ',
    contactEmailLabel: '이메일: ',
  },
  about: {
    banner: {
      alt: '회사 소개 배너',
      title: 'Zetok는 혁신 교육에 집중하며 고품질 키트와 과정을 제공합니다',
      image: require('@/assets/about/banner.png'),
    },
    mission: {
      title: '우리의 사명',
      desc: '첨단 인공지능 기술로 교육을 강화하고 혁신을 촉발하여 미래의 리더와 혁신가를 양성하는 것이 우리의 사명입니다. 우리는 고품질의 교육 도구와 솔루션을 제공함으로써 학생과 교육자가 잠재력을 실현하도록 도울 수 있다고 믿습니다.',
      image: require('@/assets/about/mission.png'),
    },
    vision: {
      title: '우리의 비전',
      desc: '기술로 교육을 강화하여 모든 학생이 양질의 STEM 자원을 접하고 잠재력을 발휘하며 미래의 혁신가와 리더로 성장하도록 돕습니다.',
      image: require('@/assets/about/vision.png'),
    },
    products: {
      title: '우리의 제품',
      tabs: ['키트', '과정', '레이저 장비'],
      items: [
        {
          title: '키트',
          desc: '인공지능, 로봇공학, 프로그래밍, 과학 실험 등 다양한 STEM 키트를 제공하며, 정교하게 설계되어 사용하기 쉽고 다양한 연령대의 학생에게 적합합니다.',
          image: require('@/assets/about/kits.png'),
        },
        {
          title: '과정',
          desc: '당사의 과정은 교육 전문가가 정교하게 설계하여 키트와 결합해 종합적인 학습 경험을 제공합니다. 기초 개념부터 고급 응용까지 포함하여 다양한 수준의 학습자에게 적합합니다.',
          image: require('@/assets/about/courses.png'),
        },
        {
          title: '레이저 장비',
          desc: '안전하고 사용하기 쉬운 레이저 절단 장비. 당사의 레이저 절단 및 조각 장비는 교육 환경에 맞게 설계되어 안전하고 정밀하며 사용이 쉽습니다. 이 장비는 학생들이 아이디어를 실물 작품으로 구현할 기회를 제공합니다.',
          image: require('@/assets/about/laser.png'),
        },
      ],
    },
    dealer: {
      banner: {
        alt: '함께하세요, Zetok의 딜러가 되세요',
        title: '함께하세요, Zetok의 딜러가 되세요',
        image: require('@/assets/about/dealer.png'),
      },
      intro: {
        title: '교육 분야의 새 비즈니스 기회를 열고 혁신 성과를 공유하세요!',
        desc: 'Zetok는 AI 키트, 레이저 장비 등을 통해 STEM 교육의 새로운 길을 함께 열고 학생들의 창의력을 고취합니다. 파트너로 함께하여 더 큰 미래를 만들어가요!',
        image: require('@/assets/about/dealer1.png'),
      },
      mission: {
        title: '우리의 사명',
        items: [
          {
            title: '선도적 제품',
            desc: '시장 최고의 STEAM 교육 도구를 제공합니다.',
            image: require('@/assets/about/dealer-mission-1.png'),
          },
          {
            title: '풍부한 수익',
            desc: '경쟁력 있는 할인과 판매 인센티브를 제공합니다.',
            image: require('@/assets/about/dealer-mission-2.png'),
          },
          {
            title: '마케팅 지원',
            desc: '마케팅 자료와 영업 교육을 제공하여 빠르게 시장을 개척하도록 돕습니다.',
            image: require('@/assets/about/dealer-mission-3.png'),
          },
          {
            title: '브랜드 협력',
            desc: 'Zetok와 협력하여 브랜드 영향력과 시장 자원을 공유합니다.',
            image: require('@/assets/about/dealer-mission-4.png'),
          },
        ],
      },
    },
    cooperation: {
      banner: {
        alt: '협력 배너',
        title: '제품 협력',
        cta: '지금 문의',
        ctaLink: '/about#contact',
        image: require('@/assets/about/coop-introbanner.png'),
      },
      intro: {
        title: '미래의 과학자와 엔지니어의 잠재력을 깨우다',
        desc: '당사의 STEM 교육 프로모션 프로그램에 참여하여 교육자를 위한 특별 혜택과 제품 체험을 받아보세요. 우리는 교실에 혁신적인 STEM 도구와 독점 할인 혜택을 제공하여 차세대 혁신가와 문제 해결자를 양성하도록 돕습니다.',
        image: require('@/assets/about/coop-introbanner1.png'),
      },
      stem: {
        title: '지금 시작하세요, STEM 교육의 새 장을 열어보세요!',
        items: [
          {
            title: '무료 제품 체험',
            desc: '구매 전에 당사 도구를 미리 경험해 보세요.',
            image: require('@/assets/about/edu1.png'),
          },
          {
            title: '독점 할인',
            desc: '교실이나 학교에 경제적인 STEM 솔루션을 제공합니다.',
            image: require('@/assets/about/edu2.png'),
          },
          {
            title: '교육 자료',
            desc: '풍부한 교수 자료와 커리큘럼을 제공하여 교육 활동을 지원합니다.',
            image: require('@/assets/about/edu3.png'),
          },
        ],
      },
      contact: {
        title: '문의하기',
        desc: '문의나 요청이 있으시면 언제든 연락 주세요. 성심껏 도와드리겠습니다.',
        image: require('@/assets/about/kites.png'),
      },
    },
    news: {
      banner: {
        alt: '뉴스 센터 배너',
        title: '뉴스 센터',
        image: require('@/assets/about/newsbanner.png'),
      },
      title: '뉴스 센터',
      tabs: [
        { key: 'company', label: '회사 소식' },
        { key: 'industry', label: '업계 동향' },
        { key: 'expo', label: '박람회 소식' },
      ],
      data: {
        company: [
          {
            id: 'company-1',
            title: 'Zetok, 새로운 교실용 AI 키트 출시',
            date: '2025-04-22',
            image: 'https://picsum.photos/seed/news-company-1-zh/560/342',
          },
          {
            id: 'company-2',
            title: '지역 학교와 협력해 STEM 시범 프로젝트 진행',
            date: '2025-04-15',
            image: 'https://picsum.photos/seed/news-company-2-zh/560/342',
          },
          {
            id: 'company-3',
            title: '소프트웨어 업데이트로 수업 관리 경험 개선',
            date: '2025-03-30',
            image: 'https://picsum.photos/seed/news-company-3-zh/560/342',
          },
          {
            id: 'company-4',
            title: '교사 연수 워크숍 개최',
            date: '2025-03-18',
            image: 'https://picsum.photos/seed/news-company-4-zh/560/342',
          },
          {
            id: 'company-5',
            title: '유통망이 더 많은 지역으로 확대',
            date: '2025-03-02',
            image: 'https://picsum.photos/seed/news-company-5-zh/560/342',
          },
          {
            id: 'company-6',
            title: '신규 과정 시리즈, 실제 프로젝트 실습에 집중',
            date: '2025-02-20',
            image: 'https://picsum.photos/seed/news-company-6-zh/560/342',
          },
          {
            id: 'company-7',
            title: '연말 결산에서 혁신 성과 부각',
            date: '2025-02-05',
            image: 'https://picsum.photos/seed/news-company-7-zh/560/342',
          },
          {
            id: 'company-8',
            title: '지역 사회 공익 프로그램으로 청소년에게 STEM 제공',
            date: '2025-01-25',
            image: 'https://picsum.photos/seed/news-company-8-zh/560/342',
          },
        ],
        industry: [
          {
            id: 'industry-1',
            title: '글로벌 트렌드: STEM에서 프로젝트 기반 학습의 활용',
            date: '2025-04-10',
            image: 'https://picsum.photos/seed/news-industry-1-zh/560/342',
          },
          {
            id: 'industry-2',
            title: '교육 속 AI: 새롭게 떠오르는 모범 사례',
            date: '2025-03-25',
            image: 'https://picsum.photos/seed/news-industry-2-zh/560/342',
          },
          {
            id: 'industry-3',
            title: '새 교육과정 기준, 실습 역량 강조',
            date: '2025-03-12',
            image: 'https://picsum.photos/seed/news-industry-3-zh/560/342',
          },
          {
            id: 'industry-4',
            title: '교육 하드웨어가 교실 사용 요구에 더 밀착',
            date: '2025-02-28',
            image: 'https://picsum.photos/seed/news-industry-4-zh/560/342',
          },
          {
            id: 'industry-5',
            title: '각 학군에서 STEAM 프로젝트 지속 추진',
            date: '2025-02-14',
            image: 'https://picsum.photos/seed/news-industry-5-zh/560/342',
          },
          {
            id: 'industry-6',
            title: '지속가능성 프로젝트가 STEM 교실로',
            date: '2025-01-30',
            image: 'https://picsum.photos/seed/news-industry-6-zh/560/342',
          },
          {
            id: 'industry-7',
            title: '메이커 스페이스가 혁신적인 학습 방식에 영향',
            date: '2025-01-16',
            image: 'https://picsum.photos/seed/news-industry-7-zh/560/342',
          },
        ],
        expo: [
          {
            id: 'expo-1',
            title: 'Zetok, 교육 기술 박람회 참가',
            date: '2025-04-05',
            image: 'https://picsum.photos/seed/news-expo-1-zh/560/342',
          },
          {
            id: 'expo-2',
            title: '지역 박람회에서 학생 프로젝트 성과 전시',
            date: '2025-03-22',
            image: 'https://picsum.photos/seed/news-expo-2-zh/560/342',
          },
          {
            id: 'expo-3',
            title: '메이커 행사에서 현장 인터랙티브 데모로 관심 집중',
            date: '2025-03-08',
            image: 'https://picsum.photos/seed/news-expo-3-zh/560/342',
          },
          {
            id: 'expo-4',
            title: '교사용 비주얼 프로그래밍 워크숍',
            date: '2025-02-21',
            image: 'https://picsum.photos/seed/news-expo-4-zh/560/342',
          },
          {
            id: 'expo-5',
            title: '신규 장비, 교육 파트너 대상 공개',
            date: '2025-02-09',
            image: 'https://picsum.photos/seed/news-expo-5-zh/560/342',
          },
        ],
      },
    },
  },
  finance: {
    contact: {
      success: '제출이 완료되었습니다. 최대한 빨리 연락드리겠습니다.',
      error: '제출에 실패했습니다. 잠시 후 다시 시도해 주세요.',
      networkError: '네트워크 오류입니다. 연결 확인 후 다시 시도해 주세요.',
    },
  },
  footer: {
    subscribePlaceholder: '휴대폰 번호와 이메일 주소',
    subscribe: '구독',
    subscribeSuccess: '구독이 완료되었습니다',
    contact: {
      sales: '영업 핫라인: +86 18379276683',
      service: '서비스 핫라인: +86 400 968 0598',
      email: '이메일: sam@zz-steam.com',
      address: '주소: 중국 선전시 푸톈구 바궈사루 화성다빌딩 A동',
    },
    icp: '개인정보처리방침 · 사용자 약관 © 중저교육(선전)유한회사 粤ICP备2024289240号-3',
  },
  solutions: {
    stem: {
      banner: {
        alt: 'STEM 교육 솔루션 배너',
        title: 'STEM 교육의 창의적 선도',
        description:
          'K12 대상 창의적 STEM 교육에 집중하여 호기심을 깨우고 논리를 기르고 프로그래밍 열정을 키웁니다.',
        image: require('@/assets/solution/banner.png'),
      },
      intro: {
        title: '인공지능과 프로그래밍 교육',
        items: [
          {
            icon: require('@/assets/solution/icon1.png'),
            title: '쉽고 간편함',
            description:
              '그래픽(블록) 프로그래밍으로 초보도 바로 시작, 손쉽게 나만의 AI 프로젝트를 만들 수 있습니다.',
          },
          {
            icon: require('@/assets/solution/icon2.png'),
            title: '강력한 기능',
            description:
              '지능형 하드웨어와 음성 상호작용으로 창의성이 무한합니다.',
          },
          {
            icon: require('@/assets/solution/icon3.png'),
            title: '확장성 우수',
            description:
              '다양한 부품과 하드웨어 연동으로 상상력을 확장하고 가능성을 넓힙니다.',
          },
          {
            icon: require('@/assets/solution/icon4.png'),
            title: '풍부한 커리큘럼',
            description:
              '기초부터 실습까지 연계된 과정으로 학생의 지식 체계를 구축합니다.',
          },
        ],
      },
      scenes: {
        title: '대표 과정 알아보기',
        items: [
          {
            tab: '학교 교육',
            title: 'AI 학교 교육',
            desc: 'AI 키트로 스마트 음성 비서를 제작하며 실습 속에서 흥미를 자극하고 논리·프로그래밍 역량을 길러 인공지능의 매력을 체험합니다.',
            image: require('@/assets/solution/tc1.png'),
          },
          {
            tab: '대회 훈련',
            title: '대회 훈련',
            desc: '스마트 키트로 로봇 대회와 기술 혁신을 지원하여 학생들이 지능형 작품을 설계하고 협력·창의 능력을 향상합니다.',
            image: require('@/assets/solution/tc2.png'),
          },
          {
            tab: '가정 학습',
            title: '가정 학습',
            desc: '부모와 함께 AI 프로젝트를 배우며 실습 능력을 기르고 관계를 증진하고 과학 소양을 높입니다.',
            image: require('@/assets/solution/tc3.png'),
          },
        ],
      },
      split: {
        title: 'AI+교육: 스마트 학습의 새 시대',
        desc: 'AI 기술로 학습 경로를 개인화하고 정밀 교육을 구현해 모든 학생이 지식의 바다에서 자유롭게 탐구하도록 돕습니다.',
        image: require('@/assets/solution/banner1.png'),
      },
      kits: {
        title: 'STEM 시리즈 키트',
        images: [
          require('@/assets/solution/kits1.png'),
          require('@/assets/solution/kits2.png'),
          require('@/assets/solution/kits3.png'),
          require('@/assets/solution/kits4.png'),
        ],
      },
    },
    makerSpace: {
      banner: {
        alt: '메이커 스페이스 솔루션 배너',
        title: '우리의 메이커 스페이스를 탐험하세요',
        description:
          '메이커 스페이스에서 교육과 혁신 기술을 결합해 학생들에게 실습과 탐구의 플랫폼을 제공합니다',
        image: require('@/assets/solution/spacebanner.png'),
      },
      intro: {
        title: '전방위 메이커 역량',
        items: [
          {
            icon: require('@/assets/solution/icon5.png'),
            title: '기술 도구 활용',
            desc: '그래픽 프로그래밍으로 손쉽게 시작, 초보자도 즉시 AI 프로젝트를 구성합니다',
          },
          {
            icon: require('@/assets/solution/icon6.png'),
            title: '개방성과 유연성',
            desc: '메이커 스페이스에서 자유롭게 탐구하며 창의력을 마음껏 펼치는 전용 놀이터입니다.',
          },
          {
            icon: require('@/assets/solution/icon7.png'),
            title: '실습 중심',
            desc: '직접 제작·실험·탐구하며 학습 여정을 시작합니다.',
          },
          {
            icon: require('@/assets/solution/icon8.png'),
            title: '협업 학습',
            desc: '학생들이 팀에서 협력하도록 장려해 팀워크와 의사소통 능력을 길러줍니다.',
          },
        ],
      },
      scenes: {
        title: '메이커 스페이스 적용 장면',
        items: [
          {
            tab: '학교 제작·공예 수업',
            title: '학교 제작·공예 수업',
            desc: '수공예 제작, 미술 디자인 등의 과목을 효과적으로 보완합니다.',
            image: require('@/assets/solution/tc4.png'),
          },
          {
            tab: '창의 연구·실습 동아리',
            title: '창의 연구·실습 동아리',
            desc: '학교의 혁신 실습 동아리에 실습 플랫폼을 제공합니다',
            image: require('@/assets/solution/tc5.png'),
          },
          {
            tab: '교육 실험실',
            title: '교육 실험실',
            desc: '학교·대학·연구실에 적합하며 학습 환경을 개선하고 학생에게 전문 레이저 조각기를 제공합니다.',
            image: require('@/assets/solution/tc6.png'),
          },
        ],
      },
      split: {
        title: '창의 실현의 도구',
        desc: '레이저 커팅기의 정밀 절단 능력과 프로그래밍 로봇의 지능형 상호작용으로 추상적 아이디어를 구체적 실물 작품으로 구현합니다',
        image: require('@/assets/solution/banner2.png'),
      },
      kits: {
        title: '메이커 시리즈 키트',
        images: [
          require('@/assets/solution/kits5.png'),
          require('@/assets/solution/kits6.png'),
          require('@/assets/solution/kits7.png'),
          require('@/assets/solution/kits8.png'),
        ],
      },
    },
  },
  software: {
    banner: {
      alt: '소프트웨어 페이지 배너',
      title: 'Zetok 소프트웨어 센터',
      image: require('@/assets/software/banner.png'),
    },
    download: {
      title: '소프트웨어 다운로드',
      items: [
        {
          key: 'lightmaker-app',
          icon: 'https://picsum.photos/seed/sw-app-1/88/88',
          name: 'Light Maker 앱',
          buttonText: '모바일 앱 다운로드',
          link: '#',
        },
        {
          key: 'goodlaser-lightmaker',
          icon: 'https://picsum.photos/seed/sw-app-2/88/88',
          name: 'Good‑laser Light Maker',
          buttonText: '클라이언트 다운로드',
          link: '#',
        },
        {
          key: 'zz-learning-app',
          icon: 'https://picsum.photos/seed/sw-app-3/88/88',
          name: '중저교육 학습 플랫폼 앱',
          buttonText: '모바일 앱 다운로드',
          link: '#',
        },
        {
          key: 'zz-learning-platform',
          icon: 'https://picsum.photos/seed/sw-app-4/88/88',
          name: '중저테크 학습 플랫폼',
          buttonText: '클라이언트 다운로드',
          link: '#',
        },
      ],
    },
    intro: {
      'goodlaser-lightmaker': {
        header: {
          title: 'Light Maker 레이저 장비 전용 소프트웨어',
          desc: '그래픽 설계와 장비 제어를 하나로 통합하여 시간을 절약하고 일체형 설계·레이저 제어 솔루션을 제공합니다.',
        },
        items: [
          {
            image: 'https://picsum.photos/seed/zh-intro-1/514/403',
            title: '강력하면서 사용하기 쉬운 설계 시스템',
            desc: '강력한 제작 소프트웨어로 JPG, DXF, AI, DST, PNG, BMP, TIF, SVG 등 고품질 디자인 포맷을 호환합니다. DWG, DXF, AI, DST, PNG, BMP, TIF, SVG 등을 지원합니다.',
          },
          {
            image: 'https://picsum.photos/seed/zh-intro-2/514/403',
            title: '전문성',
            desc: '전문적인 그리기 기능으로 모든 제작 요구를 충족합니다. 복잡한 디자인부터 단순 절단까지 쉽게 처리합니다.',
          },
          {
            image: 'https://picsum.photos/seed/zh-intro-3/514/403',
            title: '쉬운 조작',
            desc: '사용자 친화적인 인터페이스로 다양한 레이저 장비를 지원합니다. 사용 편의성, 다기능 인터페이스, 효율적인 절단과 각인 처리 능력을 갖추었습니다.',
          },
        ],
      },
      'lightmaker-app': {
        header: {
          title: 'Light Maker 레이저 장비 전용 소프트웨어',
          desc: '그래픽 설계와 장비 제어를 하나로 통합하여 시간을 절약하고 일체형 설계·레이저 제어 솔루션을 제공합니다.',
        },
        items: [
          {
            image: 'https://picsum.photos/seed/zh-intro-1/514/403',
            title: '강력하면서 사용하기 쉬운 설계 시스템',
            desc: '강력한 제작 소프트웨어로 JPG, DXF, AI, DST, PNG, BMP, TIF, SVG 등 고품질 디자인 포맷을 호환합니다. DWG, DXF, AI, DST, PNG, BMP, TIF, SVG 등을 지원합니다.',
          },
          {
            image: 'https://picsum.photos/seed/zh-intro-2/514/403',
            title: '전문성',
            desc: '전문적인 그리기 기능으로 모든 제작 요구를 충족합니다. 복잡한 디자인부터 단순 절단까지 쉽게 처리합니다.',
          },
          {
            image: 'https://picsum.photos/seed/zh-intro-3/514/403',
            title: '쉬운 조작',
            desc: '사용자 친화적인 인터페이스로 다양한 레이저 장비를 지원합니다. 사용 편의성, 다기능 인터페이스, 효율적인 절단과 각인 처리 능력을 갖추었습니다.',
          },
        ],
      },
      'zz-learning-app': {
        header: {
          title: 'Zetok 클라우드 플랫폼',
          desc: '클라우드 플랫폼은 교사, 학생, 학교를 위한 원스톱 교육 관리 도구입니다. 본 플랫폼을 통해 과제 수발, 장비 모니터링, 수리 접수, 파라미터 설정 등의 작업을 손쉽게 수행할 수 있습니다.',
        },
        items: [
          {
            image: 'https://picsum.photos/seed/zh-intro-app-1/514/403',
            title: '편리한 조작',
            desc: '원클릭 제작: 내장 이미지 라이브러리와 파라미터 구성으로 원클릭 제작을 지원하여 작업 흐름을 단순화합니다. 장비 모니터링: 장비 상태를 실시간으로 확인해 수업이 원활히 진행되도록 합니다.',
          },
          {
            image: 'https://picsum.photos/seed/zh-intro-app-2/514/403',
            title: '통합 관리',
            desc: '장비 병렬: 메이커 교실의 기타 장비 병렬 연결을 지원하고, 원클릭 관리 기능으로 관리 효율을 높입니다.',
          },
          {
            image: 'https://picsum.photos/seed/zh-intro-app-3/514/403',
            title: '실시간 모니터링',
            desc: '장비 상태: 장비의 작동 상태를 실시간으로 파악하고, 고장 발생 시 즉시 수리를 접수합니다. 유지 보수: 시스템이 장비의 작동 시간과 사용 빈도에 따라 정기적인 유지 보수를 안내해 장비 수명을 연장하고 절단 품질을 향상합니다.',
          },
        ],
      },
      'zz-learning-platform': {
        header: {
          title: 'Zetok 학습 플랫폼',
          desc: 'Zetok 학습 플랫폼은 학생과 교사를 위한 종합적인 과학 교육 소프트웨어 솔루션을 제공하는 혁신적인 온라인 학습 도구입니다. 모바일 기기나 컴퓨터에서 쉽게 접속하여 사용할 수 있습니다.',
        },
        items: [
          {
            image: 'https://picsum.photos/seed/zh-intro-learn-app-1/514/403',
            title: '스마트하고 편리, 초보도 안심',
            desc: '내장된 풍부한 이미지 라이브러리와 사전 설정 파라미터로 원클릭 제작을 지원하여 초보도 빠르게 익힙니다. 모바일 초보자 안내가 상세하여 작업 방법을 쉽게 익힐 수 있습니다. 클라우드 서비스는 백그라운드에서 교실 장비의 작동 상태를 실시간 모니터링해 수업을 안전하고 효율적으로 진행합니다.',
          },
          {
            image: 'https://picsum.photos/seed/zh-intro-learn-app-2/514/403',
            title: 'AI 창작',
            desc: '원클릭 제작과 AI 이미지 생성 기능은 설계 과정을 단순화하고 창작 효율을 높입니다. 사용자는 간단한 지시를 입력하거나 참조 이미지를 업로드하기만 하면 AI가 자동으로 고품질·절단 친화적인 소재를 생성합니다.',
          },
          {
            image: 'https://picsum.photos/seed/zh-intro-learn-app-3/514/403',
            title: '효율적 학습의 새로운 경험',
            desc: 'Zetok 학습 플랫폼은 강의 학습, 그래픽 설계, 레이저 커팅 가공을 하나로 통합하여 조작이 간단하고 편리해 빠르게 익힐 수 있습니다. 홈 화면은 카드형 디자인을 사용해 강의 학습, 그래픽 설계, 레이저 커팅 가공 등 모듈을 명확히 구분하여 학습·설계·가공이 매끄럽게 연결되도록 하여 학습 효율을 크게 높입니다.',
          },
        ],
      },
    },
  },
  product: {
    farm: {
      banner: {
        alt: '스마트 농장 배너',
        title: '스마트 농장 학습 키트',
        btnText: '지금 구매',
        description:
          '프로젝트 기반 수업 | 프로그래밍+하드웨어+AI | 초중등 적용',
        image: require('@/assets/product/farm/banner.png'),
      },
      sections: {
        courseTitle: '프로젝트 강의 내용',
        resourceTitle: '교육 자료',
        equipmentsTitle: '장비 구성',
      },
      courses: [
        {
          bg: '#FBBC05',
          txt: '#fff',
          title: '다채로운 강의 구성',
          desc: '12강으로 기초에서 심화까지: 온도 감지부터 스마트 급수·온도 제어까지 단계적 학습.',
          image: require('@/assets/product/farm/education1.png'),
        },
        {
          bg: '#4285F4',
          txt: '#fff',
          title: '융합형 지식 학습',
          desc: '각 프로젝트는 프로그래밍, 전자 하드웨어, 기계 구조 등 다학문을 포함해 실습 속에서 종합 활용 능력을 키웁니다.',
          image: require('@/assets/product/farm/education2.png'),
        },
        {
          bg: '#EA4335',
          txt: '#fff',
          title: '생활 밀착형 주제',
          desc: '스마트 농장을 주제로 학생의 생활과 맞닿아 흥미와 참여를 이끌어냅니다.',
          image: require('@/assets/product/farm/education3.png'),
        },
      ],
      resources: [
        {
          title: '완성도 높은 수업 PPT와 강의안',
          desc: '16차시 수업 PPT와 강의안이 프로젝트와 긴밀히 연계되어, 풍부한 자료로 교사의 준비 부담을 덜어줍니다.',
          image: require('@/assets/product/farm/edu1.png'),
        },
        {
          title: '프로젝트 조립 영상',
          desc: '영상 자료가 프로젝트 구성 과정을 직관적으로 보여 주어 학생이 절차를 더 잘 이해하고 익히도록 도와 학습 효율을 높입니다.',
          image: require('@/assets/product/farm/edu2.png'),
        },
        {
          title: '보조 학습 자료',
          desc: '강의안 등 보조 자료가 학생에게 더 상세한 학습 지침을 제공하여 복습과 자율 학습에 도움이 됩니다.',
          image: require('@/assets/product/farm/edu3.png'),
        },
      ],
      equipments: [
        {
          title: 'RGB LED 스트립',
          image: require('@/assets/product/kits/kits1.png'),
        },
        {
          title: 'DS1307 시계 모듈',
          image: require('@/assets/product/kits/kits2.png'),
        },
        {
          title: 'DHT11 온습도 센서',
          image: require('@/assets/product/kits/kits3.png'),
        },
        {
          title: '인체 감지 센서',
          image: require('@/assets/product/kits/kits4.png'),
        },
        {
          title: 'LED 조명 모듈',
          image: require('@/assets/product/kits/kits5.png'),
        },
        {
          title: '팬 모듈',
          image: require('@/assets/product/kits/kits10.png'),
        },
        {
          title: '슬롯형 포토커플러 스위치',
          image: require('@/assets/product/kits/kits9.png'),
        },
        {
          title: '버튼 모듈',
          image: require('@/assets/product/kits/kits8.png'),
        },
        {
          title: '컨트롤 보드',
          image: require('@/assets/product/kits/kits7.png'),
        },
        {
          title: '확장 보드',
          image: require('@/assets/product/kits/kits6.png'),
        },
      ],
    },
    home: {
      banner: {
        alt: '스마트 홈 학습 키트',
        title: '스마트 홈 학습 키트',
        btnText: '지금 구매',
        description:
          '프로그래밍과 AI 입문 | 프로젝트 기반 수업 | 초중등 과학 수업의 최적 선택',
        image: require('@/assets/product/home/banner.png'),
      },
      resourcesTitle: '스마트 홈 입문 키트의 장점',
      resources: [
        {
          title: '풍부한 자료',
          desc: '완전한 교육 자료를 제공하여 교사의 수업과 학생의 학습을 돕습니다.',
          image: require('@/assets/product/home/adv1.png'),
        },
        {
          title: '융합 학습',
          desc: '각 프로젝트는 프로그래밍, 전자 하드웨어, 기계 구조 등 다양한 학문을 포함하여 실습 속에서 종합 적용 능력을 높입니다.',
          image: require('@/assets/product/home/adv2.png'),
        },
        {
          title: '과제 확장 활동',
          desc: '확장 과제와 융합 응용 제안을 통해 탐구와 창작을 촉진합니다.',
          image: require('@/assets/product/home/adv3.png'),
        },
      ],
      course: {
        title: '연계 강좌',
        desc: '12가지 프리미엄 프로젝트 강좌를 포함하며, 전자 도어벨, 조도 조절 현관등, 감지식 차고, 비밀번호 출입, 가스 경보, 도난 경보, 화려한 LED 조명, 음악 분위기등, 일광 감지, 실내 온도 감지 및 온도 제어 팬 등 스마트 홈의 다양한 측면을 다룹니다.',
        image: require('@/assets/product/home/banner2.png'),
      },
      scenesTitle: '다양한 활용 장면',
      scenes: [
        {
          title: '교실 수업',
          image: require('@/assets/product/home/c1.png'),
        },
        {
          title: '개별 창의 개발',
          image: require('@/assets/product/home/c2.png'),
        },
        {
          title: '가정의 부모-자녀 활동',
          image: require('@/assets/product/home/c3.png'),
        },
        {
          title: '행사 전시',
          image: require('@/assets/product/home/c4.png'),
        },
      ],
      equipmentsTitle: '장비 구성',
      equipments: [
        {
          title: 'RGB LED 스트립',
          image: require('@/assets/product/kits/kits1.png'),
        },
        {
          title: 'DS1307 시계 모듈',
          image: require('@/assets/product/kits/kits2.png'),
        },
        {
          title: 'DHT11 온습도 센서',
          image: require('@/assets/product/kits/kits3.png'),
        },
        {
          title: '인체 감지 센서',
          image: require('@/assets/product/kits/kits4.png'),
        },
        {
          title: 'LED 조명 모듈',
          image: require('@/assets/product/kits/kits5.png'),
        },
        {
          title: '팬 모듈',
          image: require('@/assets/product/kits/kits10.png'),
        },
        {
          title: '슬롯형 포토커플러 스위치',
          image: require('@/assets/product/kits/kits9.png'),
        },
        {
          title: '버튼 모듈',
          image: require('@/assets/product/kits/kits8.png'),
        },
        {
          title: '컨트롤 보드',
          image: require('@/assets/product/kits/kits7.png'),
        },
        {
          title: '확장 보드',
          image: require('@/assets/product/kits/kits6.png'),
        },
      ],
    },
    factory: {
      banner: {
        alt: '스마트 공장 배너',
        title: '스마트 공장 학습 키트',
        btnText: '지금 구매',
        description: ` · 센싱/제어/구동 전 영역 커버 <br>
 · 실제 생산라인 모사<br>
 · 미래 엔지니어 양성`,
        image: require('@/assets/product/factory/banner.png'),
      },
      resourcesTitle: '제품 특징',
      resources: [
        {
          title: '인더스트리 4.0 핵심 체험',
          desc: '모의 생산라인에서 센싱, 제어, 구동, 데이터 관리를 익힙니다.',
          image: require('@/assets/product/factory/tc1.png'),
        },
        {
          title: '프로젝트 기반 학습',
          desc: '프로그래밍 튜토리얼과 PPT가 포함된 12차시 강좌로 학습이 편리합니다.',
          image: require('@/assets/product/factory/tc2.png'),
        },
        {
          title: '실제 장면 모사',
          desc: '지능형 로봇팔, 자동 분류 시스템, 스마트 창고로 물류 재고 관리를 모사하여 STEM 실습의 여정을 시작합니다.',
          image: require('@/assets/product/factory/tc3.png'),
        },
      ],
      intro: {
        title: '제품 소개',
        desc: '스마트 공장 학습 세트는 프로그래밍, 전자 하드웨어, 기계 구조, 레이저 커팅 및 인공지능 기초 학습을 결합한 프로젝트형 교육 키트로, 초중등 학생의 사용과 수업에 적합합니다. “지능형 제조·미래를 창조하다”를 주제로 모의 생산 환경을 통해 과학적 탐구, 엔지니어링 설계, 프로그래밍 제어 및 협력적 혁신 능력을 길러 줍니다.',
        bg: require('@/assets/product/factory/product.png'),
      },
      course: {
        title: '연계 강좌',
        desc: '12가지 프리미엄 강좌: 스마트 공장 입문, 생산 공정 이해, 센서 응용, 기계 구동 기초, 컨베이어 시스템 구축, 자동 분류, 공정 협업 제어, 조립 로봇팔, 스마트 분류 등. 제어와 데이터 수집 등 주제를 프로젝트형으로 설계하여 실습과 체계적 훈련을 강조합니다.',
        image: require('@/assets/product/factory/course.png'),
      },
      equipmentsTitle: '장비 구성',
      equipments: [
        {
          title: 'RGB LED 스트립',
          image: require('@/assets/product/kits/kits1.png'),
        },
        {
          title: 'DS1307 시계 모듈',
          image: require('@/assets/product/kits/kits2.png'),
        },
        {
          title: 'DHT11 온습도 센서',
          image: require('@/assets/product/kits/kits3.png'),
        },
        {
          title: '인체 감지 센서',
          image: require('@/assets/product/kits/kits4.png'),
        },
        {
          title: 'LED 조명 모듈',
          image: require('@/assets/product/kits/kits5.png'),
        },
        {
          title: '팬 모듈',
          image: require('@/assets/product/kits/kits10.png'),
        },
        {
          title: '슬롯형 포토커플러 스위치',
          image: require('@/assets/product/kits/kits9.png'),
        },
        {
          title: '버튼 모듈',
          image: require('@/assets/product/kits/kits8.png'),
        },
        {
          title: '컨트롤 보드',
          image: require('@/assets/product/kits/kits7.png'),
        },
        {
          title: '확장 보드',
          image: require('@/assets/product/kits/kits6.png'),
        },
      ],
    },
    kits: {
      laserSteam: {
        banner: {
          alt: '레이저 커팅 STEAM 키트 배너',
          title: '레이저 커팅 STEAM 키트',
          btnText: '지금 구매',
          description:
            '혁신 사고와 팀 협업을 길러 주는 원스톱 제조 교육 솔루션',
          image: require('@/assets/product/laser-steam/banner.png'),
        },
        aiBanner: {
          title: 'AI 교육, 스마트한 출발',
          desc: 'STEAM 교육에 AI 요소를 접목하여 종합적인 학습 경험을 제공합니다.',
        },
        resourcesTitle: '레이저 커팅 STEAM 키트의 장점',
        resources: [
          {
            title: '다중지능 이론',
            desc: '다중지능 이론을 바탕으로 창의력, 비판적 사고, 문제 해결, 의사소통·협업 능력을 기릅니다.',
            image: require('@/assets/product/laser-steam/adv1.png'),
          },
          {
            title: '프로젝트 기반 학습',
            desc: '프로젝트형 학습을 통해 실습 속에서 배우며 학습 효율과 흥미를 높입니다.',
            image: require('@/assets/product/laser-steam/adv2.png'),
          },
          {
            title: 'STEAM 교육',
            desc: '과학, 기술, 공학, 예술, 수학 등 여러 학문을 융합하여 학생의 융합적 사고를 형성하도록 돕습니다.',
            image: require('@/assets/product/laser-steam/adv3.png'),
          },
        ],
        teach: {
          title: '연계 상세 교육',
          tabs: [
            { key: 'cutter', label: '레이저 커팅기' },
            { key: 'lesson', label: '연계 강좌' },
            { key: 'material', label: '교육 자료' },
            { key: 'software', label: '소프트웨어' },
          ],
          images: {
            cutter: require('@/assets/product/laser-steam/cutter.png'),
            lesson: require('@/assets/product/laser-steam/lesson.png'),
            material: require('@/assets/product/laser-steam/material.png'),
            software: require('@/assets/product/laser-steam/software.png'),
          },
        },
        equipmentsTitle: '장비 구성',
      },
      // 逐梦科学套件（Dream Science Kit）
      dreamScience: {
        banner: {
          alt: '드림 사이언스 키트 배너',
          title: '신비한 과학 보물상자(드림 사이언스 키트)',
          description: '과학 개념 | 과학적 사고 | 탐구 실습 | 태도와 책임',
          image: require('@/assets/product/dream-science/banner.png'),
        },
        resourcesTitle: '키트 구성',
        resources: [
          {
            title: '과학 실험 재료',
            desc: '다양한 과학 실험과 프로젝트를 수행하는 데 사용됩니다.',
            image: require('@/assets/product/dream-science/kits1.png'),
          },
          {
            title: '교육 자료',
            desc: '수업 PPT와 강의안을 포함하며 한 학기 수업을 지원합니다. 내용은 수업 프로젝트와 지식 포인트에 긴밀히 대응합니다.',
            image: require('@/assets/product/dream-science/kits2.png'),
          },
          {
            title: '조립 영상과 강의안',
            desc: '보조 교육 자료로 학생이 절차를 더 잘 이해하고 익히도록 돕습니다.',
            image: require('@/assets/product/dream-science/kits3.png'),
          },
        ],
        objectivesTitle: '교육 목표',
        objectives: [
          {
            title: '과학 탐구 능력',
            desc: '문제 제기, 계획 수립, 데이터 수집 및 분석',
            image: require('@/assets/product/dream-science/education1.png'),
          },
          {
            title: '공학 실습 능력',
            desc: '직접 구축과 테스트, 반복 개선',
            image: require('@/assets/product/dream-science/education2.png'),
          },
          {
            title: '융합 학습',
            desc: '수학·물리·예술을 결합해 프로젝트 완성',
            image: require('@/assets/product/dream-science/education3.png'),
          },
        ],
        intro: {
          title: '적용 대상',
          description:
            '초·중학생: 다양한 연령대의 학생에게 적합하며 과학 소양과 실습 능력을 높이는 데 도움이 됩니다. 교사: 교사에게 교육 자료와 가이드를 제공해 수업 활동을 더 잘 진행할 수 있도록 돕습니다.',
          image: require('@/assets/product/dream-science/banner1.png'),
          alt: '소개 섹션 이미지',
        },
      },
    },
    // 查看所有套件页面
    kitsViewAll: {
      banner: {
        alt: '전체 키트 보기 배너',
        title: '키트 시리즈',
        image: require('@/assets/product/kitsall/banner.png'),
      },
      contentTitle:
        '프로젝트를 핵심으로 하여 학생이 다양한 과제 수행을 통해 지식을 종합적으로 적용하고 문제 해결 능력을 기릅니다.',
      moreText: '자세히 보기',
      items: [
        {
          image: require('@/assets/product/kitsall/kits1.png'),
          title: '스마트 농장 학습 키트',
          desc: '以项目为核心，激发学生创造力和动手实践能力，培养解决实际问题的技巧。',
          link: '/products/laser-steam',
        },
        {
          image: require('@/assets/product/kitsall/kits2-1.png'),
          title: '스마트 홈 학습 키트',
          desc: '프로그래밍, 전자 하드웨어, 기계 구조, 레이저 커팅 및 인공지능 기초를 결합하여 포괄적 학습 경험을 제공합니다.',
          link: '/products/dream-science',
        },
        {
          image: require('@/assets/product/kitsall/kits2-2.png'),
          title: '스마트 교통 학습 키트',
          desc: '프로그래밍, 전자 하드웨어, 기계 구조, 레이저 커팅 및 인공지능 기초를 한데 모은 프로젝트형 교육 키트입니다.',
          link: '/products',
        },
        {
          image: require('@/assets/product/kitsall/kits2-3.png'),
          title: '스마트 공장 학습 키트',
          desc: '인공지능 기초 지식과 실제 사례를 포함해 단계적으로 학습을 안내하고 지식 체계를 구축하도록 돕습니다.',
          link: '/products/traffic',
        },
        // {
        //   image: require('@/assets/product/kitsall/kits2.png'),
        //   title: '레이저 커팅 STEAM 키트',
        //   desc: '레이저 커팅 STEAM 강좌 키트는 다중지능 이론, STEAM 교육 철학 및 프로젝트형 학습 이론 등을 바탕으로 설계되었습니다.',
        //   link: '/products/home',
        // },
        // {
        //   image: require('@/assets/product/kitsall/kits2.png'),
        //   title: '드림 사이언스 키트',
        //   desc: '드림 사이언스 키트는 다양한 학습 단계의 요구를 충족해 학생의 과학적 관심과 탐구 정신을 자극합니다.',
        //   link: '/products/farm',
        // },
      ],
    },
    traffic: {
      banner: {
        alt: '스마트 교통 배너',
        title: '스마트 교통 학습 키트',
        btnText: '지금 구매',
        description: `12개 프로젝트형 강좌 
  <br>· 그래픽/Python 이중 프로그래밍  <br>
 · 현실 시나리오 시뮬레이션<br>
 · 열자마자 바로 수업`,
        image: require('@/assets/product/traffic/banner.png'),
      },
      resourcesTitle: '제품 특징',
      resources: [
        {
          title: '과학 탐구와 혁신',
          desc: '학생들이 전자 모듈과 기계 구조로 스마트 교통 시스템을 구축합니다',
          image: require('@/assets/product/traffic/traffic1.png'),
        },
        {
          title: '교육성 우수',
          desc: '스마트 가로등, 신호등, 횡단보도, 주차장 등 프로젝트를 구축하여 스마트 교통 개념을 이해하도록 돕습니다.',
          image: require('@/assets/product/traffic/traffic2.png'),
        },
        {
          title: '풍부한 자료',
          desc: '12차시 수업용 PPT와 강의안, 프로젝트형 강좌의 조립 영상과 강의안 등 보조 자료를 포함한 완전한 교육 자료를 제공합니다.',
          image: require('@/assets/product/traffic/traffic3.png'),
        },
      ],
      intro: {
        title: '제품 소개',
        desc: '스마트 교통 초중등 키트는 “스마트 이동”과 “교통 안전”을 주제로 전자 제어, 센서 등 기술을 결합하여 학생이 스마트 교통 시스템을 직접 설계·구축하도록 이끕니다. 실제 교통 장면을 시뮬레이션하여 과학 소양과 혁신 능력을 기릅니다.',
        bg: require('@/assets/product/traffic/banner1.png'),
      },
      course: {
        title: '연계 강좌',
        desc: '교통 감지와 제어 기초, 신호 연동, 경로 계획 등의 주제를 담은 프로젝트형 강좌로 다양한 단계와 수업 시간 구성에 맞게 설계되었습니다.',
        image: require('@/assets/product/traffic/course.png'),
      },
      equipmentsTitle: '장비 구성',
      equipments: [
        {
          title: 'RGB LED 스트립',
          image: require('@/assets/product/kits/kits1.png'),
        },
        {
          title: 'DS1307 시계 모듈',
          image: require('@/assets/product/kits/kits2.png'),
        },
        {
          title: 'DHT11 온습도 센서',
          image: require('@/assets/product/kits/kits3.png'),
        },
        {
          title: '인체 감지 센서',
          image: require('@/assets/product/kits/kits4.png'),
        },
        {
          title: 'LED 조명 모듈',
          image: require('@/assets/product/kits/kits5.png'),
        },
        {
          title: '팬 모듈',
          image: require('@/assets/product/kits/kits10.png'),
        },
        {
          title: '슬롯형 포토커플러 스위치',
          image: require('@/assets/product/kits/kits9.png'),
        },
        {
          title: '버튼 모듈',
          image: require('@/assets/product/kits/kits8.png'),
        },
        {
          title: '컨트롤 보드',
          image: require('@/assets/product/kits/kits7.png'),
        },
        {
          title: '확장 보드',
          image: require('@/assets/product/kits/kits6.png'),
        },
      ],
    },
    banner: {
      alt: '제품 메인 배너',
      title: 'Zetok 제품과 솔루션',
      description:
        '키트, 강좌, 장비 및 소프트웨어의 일체화로 프로젝트 기반 학습을 지원합니다',
      image: 'https://picsum.photos/id/1069/1600/900',
    },
    courses: {
      banner: {
        alt: '강좌 구성 배너',
        title: '4대 강의 체계',
        description:
          '강의 내용은 과학, 기술, 공학, 예술, 수학(STEAM)의 여러 학문 영역을 포괄하여 학생의 융합 지식 통합과 적용을 촉진합니다.',
        image: require('@/assets/product/courses/banner.png'),
      },
      design: {
        title: '대표 과정 알아보기',
        nav: ['연령 3-6세', '연령 6-12세', '연령 8-13세', '연령 9-15세'],
        entries: [
          {
            title: '과학 탐구 체계·유아(6과목)',
            desc: '일상에서 흔히 볼 수 있는 현상을 과학 교구로 더 깊이 탐구하여 사물의 발전 규칙과 원리를 이해합니다.',
            image: require('@/assets/product/courses/courses1.png'),
          },
          {
            title: 'STEAM 메이커 체계·청소년(3과목)',
            desc: '자신의 창의력을 발휘하여 장비를 활용, 실습으로 아이디어를 작품으로 전환합니다.',
            image: require('@/assets/product/courses/courses2.png'),
          },
          {
            title: '레이저 커팅 강좌 체계(3과목)',
            desc: '장비를 활용해 다양한 구조 부품을 절단하고 입체 구조로 조립하며 구조를 미화합니다. 프로그래밍 능력: 프로그래밍 판단의 논리와 원리를 이해합니다.',
            image: require('@/assets/product/courses/courses3.png'),
          },
          {
            title: '인공지능 강좌 체계(4과목)',
            desc: '장비와 도구를 사용하여 작품의 외관을 설계·제작하고, 프로그래밍으로 작품을 지능화·단순화하여 생활 속 문제를 해결합니다.',
            image: require('@/assets/product/courses/courses4.png'),
          },
        ],
        detailsTitle: '강좌 장점',
        details: [
          {
            title: '실습 중심',
            description: '직접 실습으로 이론을 기술로 전환',
            image: require('@/assets/product/courses/icon1.png'),
          },
          {
            title: '창의적 사고 함양',
            description: '직접 설계로 창의적으로 문제 해결',
            image: require('@/assets/product/courses/icon2.png'),
          },
          {
            title: '프로젝트 기반 학습',
            description: '프로젝트로 학습을 이끌어 실습 속에서 지식 습득',
            image: require('@/assets/product/courses/icon3.png'),
          },
          {
            title: '최신 기술 탐구',
            description: '기술 최전선을 따라 지능형 키트 응용을 학습',
            image: require('@/assets/product/courses/icon4.png'),
          },
          {
            title: '체계적 교육',
            description: '강의 내용이 기초에서 심화까지, 이론에서 실습까지',
            image: require('@/assets/product/courses/icon5.png'),
          },
          {
            title: '재미와 도전의 공존',
            description:
              '재미로 흥미를, 도전으로 잠재력을 끌어내 탐구 속에서 성장',
            image: require('@/assets/product/courses/icon6.png'),
          },
        ],
      },
      ai: {
        title: '인공지능 시리즈 강좌',
        items: [
          {
            name: '스마트 농장',
            image: require('@/assets/product/courses/courses5.png'),
          },
          {
            name: '스마트 홈',
            image: require('@/assets/product/courses/courses6.png'),
          },
          {
            name: '스마트 교통',
            image: require('@/assets/product/courses/courses7.png'),
          },
          {
            name: '스마트 공장',
            image: require('@/assets/product/courses/courses8.png'),
          },
        ],
      },
      aiBanner: {
        alt: 'AI 강좌 배너',
        text: '프로젝트 기반, 융합 학습으로 실습·협업·문제 해결 능력을 기릅니다. 안전과 개인화를 병행하고 성과 발표로 성취감을 높여 학생의 성장을 돕습니다.',
        image: require('@/assets/product/courses/banner1.png'),
      },
    },

    laser: {
      banner: {
        alt: '레이저 제품',
        title: 'Good Laser 레이저 제품',
        description:
          '교육 환경에 적합한 안전하고 사용하기 쉬운 레이저 절단/조각 장비 및 솔루션',
        image: require('@/assets/product/laser/banner.png'),
      },
      advantagesTitle: '당사의 강점',
      extraNote: {
        light640_640:
          '뛰어난 절단 및 조각 성능\n다양한 모델, 다양한 레이저 출력으로 다양한 응용 요구 충족\n레이저 유형: 연속 CO2  레이저 출력: 60W–130W',
      },
      center: {
        title: '제품 센터',
        laser_accessories: '레이저 액세서리',
        air_purifier_name: '공기청정기',
        description:
          '교육 수준에 맞춘 종합적인 레이저 장비 솔루션을 제공합니다. Zetok은 학교가 실제 교육 수요에 따라 선택할 수 있도록 4가지 공식 레이저 장비 솔루션을 출시했습니다.',
        tabs: [
          {
            key: 'light530',
            label: 'Light 530',
            images: [
              require('@/assets/product/laser/light530.png'),
              require('@/assets/product/laser/light530.png'),
              require('@/assets/product/laser/light530.png'),
              require('@/assets/product/laser/light530.png'),
              require('@/assets/product/laser/light530.png'),
            ],
            advantages: [
              {
                icon: require('@/assets/product/laser/tags1.png'),
                title: '고품질·고정밀 레이저',
                bgColor: '#4285F4',
                description:
                  '두꺼운 고품질 CO₂ 레이저 튜브, 파장 10640nm, 출력 55W, 최대 20mm(아크릴) 절단 가능, 작업 속도 최대 600mm/s, 반복 정밀도 0.025mm로 빠르고 정밀한 절단 및 조각이 가능합니다.',
                image: require('@/assets/product/laser/light530-1.png'),
              },
              {
                icon: require('@/assets/product/laser/tags1.png'),
                title: '일체형 3중 배기 가스 여과 시스템',
                bgColor: '#FFBC0C',
                description:
                  '필터, 활성탄, UV 오존층을 통합한 다중 연기 필터링 구조로 더욱 친환경적이며, 별도의 필터 박스가 필요 없어 공간 활용이 뛰어납니다.',
                image: require('@/assets/product/laser/light530-2.png'),
              },
              {
                icon: require('@/assets/product/laser/tags1.png'),
                title: '최고 수준의 안전 보호',
                bgColor: '#34A853',
                description:
                  'SGS 최고 안전 테스트 통과, FDA 인증 Class I 레이저 제품. 독창적인 안전 및 작동 상태 표시등 설계로 장비 상태를 직관적으로 확인할 수 있습니다.',
                image: require('@/assets/product/laser/light530-3.png'),
              },
              {
                icon: require('@/assets/product/laser/tags1.png'),
                title: '간편하고 강력한 레이저 절단 시스템',
                bgColor: '#0F9D58',
                description:
                  '· 재료별로 다른 가공 파라미터 설정 가능: 절단, 깊은 조각, 얕은 조각, 스캔 등.\n· 풍부한 도면 자료로 설계 효율 향상.\n· 카메라 정밀 촬영 지원으로 그래픽 설계를 보조하여 아이디어를 현실로 구현.',
                image: require('@/assets/product/laser/light530-4.png'),
              },
            ],
          },
          {
            key: 'light640',
            label: 'Light 640',
            images: [
              require('@/assets/product/laser/light640.png'),
              require('@/assets/product/laser/light640.png'),
              require('@/assets/product/laser/light640.png'),
              require('@/assets/product/laser/light640.png'),
              require('@/assets/product/laser/light640.png'),
            ],
            models: [
              {
                key: '640',
                label: 'Light 640',
                image: require('@/assets/product/laser/640.png'),
              },
              {
                key: '960',
                label: 'Light 960',
                image: require('@/assets/product/laser/960.png'),
              },
              {
                key: '1390',
                label: 'Light 1390',
                image: require('@/assets/product/laser/1390.png'),
              },
              {
                key: '1610',
                label: 'Light 1610',
                image: require('@/assets/product/laser/1610.png'),
              },
            ],
            modelAdvantages: {
              640: [
                {
                  icon: require('@/assets/product/laser/tags1.png'),
                  title: '작업 영역',
                  bgColor: '#4285F4',
                  description: `Light640 (600*400mm)
Light960 (900*600mm)
<br>Light1390 (1300*900mm)
<br>Light1610 (1600*1000mm)`,
                  image: require('@/assets/product/laser/640-1.png'),
                },
                {
                  icon: require('@/assets/product/laser/tags1.png'),
                  title: '자동 초점 + 레드닷 위치 지정',
                  bgColor: '#FFBC0C',
                  description:
                    '자동 초점 기능으로 절단 및 조각 전 빠르고 정확한 초점 설정이 가능하며, 레드닷 빔으로 작업 위치를 실시간으로 확인할 수 있어 시간 절약과 더 나은 결과를 제공합니다.',
                  image: require('@/assets/product/laser/640-2.png'),
                },
                {
                  icon: require('@/assets/product/laser/tags1.png'),
                  title: '개방형 후면 도어 설계',
                  bgColor: '#34A853',
                  description:
                    '개방형 후면 도어 설계로 길이에 제한 없는 소재 가공이 가능하며, 600mm × ∞ 판재 작업으로 더욱 편리하고 제약이 적습니다.',
                  image: require('@/assets/product/laser/640-3.png'),
                },
              ],
              960: [
                {
                  icon: require('@/assets/product/laser/tags1.png'),
                  title: '뛰어난 절단 및 조각 성능',
                  bgColor: '#4285F4',
                  description:
                    '넓은 절단 플랫폼을 탑재하여 목재와 아크릴 가공에서 산업용 수준의 정밀도와 효율을 달성하며, 고품질 레이저 공예품의 대량 생산이 가능합니다.',
                  image: require('@/assets/product/laser/960-1.png'),
                },
                {
                  icon: require('@/assets/product/laser/tags1.png'),
                  title: '고품질 레이저 튜브 및 정밀 부품 탑재',
                  bgColor: '#FFBC0C',
                  description:
                    '다양한 제품 라인업으로 실제 요구에 따라 레이저 유형과 가공 속도를 선택할 수 있으며, 목재·유리·아크릴 가공에 무한한 가능성을 제공합니다.',
                  image: require('@/assets/product/laser/960-2.png'),
                },
                {
                  icon: require('@/assets/product/laser/tags1.png'),
                  title: '엄격한 광학 품질 테스트, 성능 보장',
                  bgColor: '#34A853',
                  description:
                    '정밀한 광로 제어와 5회 이상의 절단·조각 테스트를 거쳐 안정적이고 균일한 출력의 최상급 CO₂ 레이저 튜브만을 선별합니다. 복잡한 디테일까지 균일한 조각이 가능합니다.',
                  image: require('@/assets/product/laser/960-3.png'),
                },
              ],
              1390: [
                {
                  icon: require('@/assets/product/laser/tags1.png'),
                  title: '종합적이고 첨단화된 안전 기능',
                  bgColor: '#4285F4',
                  description: `1. 비상 정지
<br>2. 경고등
<br>3. 방수 스위치
<br>4. 접지
<br>5. 이상 작동 시 자동 작동하는 내장형 열 감지 경보
<br>6. 덮개 보호
<br>7. 내구성 강화 유리 보호창`,
                  image: require('@/assets/product/laser/1390-1.png'),
                },
                {
                  icon: require('@/assets/product/laser/tags1.png'),
                  title: '내구성 우수, 뛰어난 품질',
                  bgColor: '#FFBC0C',
                  description: `1. 단품 프로젝트 또는 대량 생산에 적합.
<br>2. 600 × 400 mm부터 1600 × 1000 mm까지 다양한 작업 영역 선택 가능.
<br>3. 탁월한 조각 속도.
<br>4. 업계 전문가가 설계.
<br>5. 맞춤형·교육·산업용 응용에 이상적.`,
                  image: require('@/assets/product/laser/1390-2.png'),
                },
                {
                  icon: require('@/assets/product/laser/tags1.png'),
                  title: '지능형 모니터링을 통한 생산 최적화',
                  bgColor: '#34A853',
                  description:
                    '축, 레이저 헤드, 광학 부품, 렌즈 등 민감한 부품을 먼지와 오염으로부터 보호하도록 개발되어, 장시간 사용에도 안정적인 작동을 보장합니다.',
                  image: require('@/assets/product/laser/1390-3.png'),
                },
              ],
              1610: [
                {
                  icon: require('@/assets/product/laser/tags1.png'),
                  title: '자동 초점 + 레드닷 위치 지정',
                  bgColor: '#4285F4',
                  description:
                    '자동 초점 기능으로 절단과 조각 전 빠르고 정확한 초점 설정이 가능하며, 레드닷 빔으로 실시간 위치 확인이 가능해 효율과 품질이 향상됩니다.',
                  image: require('@/assets/product/laser/1610-1.png'),
                },
                {
                  icon: require('@/assets/product/laser/tags1.png'),
                  title: '뛰어난 절단 및 조각 성능',
                  bgColor: '#FFBC0C',
                  description:
                    '넓은 절단 플랫폼을 탑재하여 목재와 아크릴에서 산업용 수준의 정밀도와 효율을 구현하며, 대량 생산에 적합합니다.',
                  image: require('@/assets/product/laser/1610-2.png'),
                },
                {
                  icon: require('@/assets/product/laser/tags1.png'),
                  title: '내구성 우수, 뛰어난 품질',
                  bgColor: '#34A853',
                  description: `1. 단품 프로젝트 또는 대량 생산에 최적.
<br>2. 600 × 400 mm부터 1600 × 1000 mm까지 광범위한 작업 영역.
<br>3. 탁월한 조각 속도.
<br>4. 업계 전문가 설계.
<br>5. 맞춤형·교육·산업 응용에 이상적.`,
                  image: require('@/assets/product/laser/1610-3.png'),
                },
              ],
            },
          },
          {
            key: 'lightblue530',
            label: 'Light Blue 530',
            images: [
              require('@/assets/product/laser/blue530.png'),
              require('@/assets/product/laser/blue530.png'),
              require('@/assets/product/laser/blue530.png'),
              require('@/assets/product/laser/blue530.png'),
              require('@/assets/product/laser/blue530.png'),
            ],
            advantages: [
              {
                icon: require('@/assets/product/laser/tags1.png'),
                title: '휴대형 블루 레이저 조각기',
                bgColor: '#4285F4',
                description:
                  '세련되고 현대적이며 콤팩트한 디자인으로 가정, 학교, 작업실 어디에나 적합합니다. 금속 본체와 아크릴 커버 조합으로 책상 위에서도 완벽한 사용이 가능하며, 20W 출력으로 뛰어난 절단 성능을 제공합니다.',
                image: require('@/assets/product/laser/blue530-1.png'),
              },
              {
                icon: require('@/assets/product/laser/tags1.png'),
                title: '완전 밀폐식 가공으로 안전 확보',
                bgColor: '#FFBC0C',
                description:
                  '완전 밀폐 구조로 작동 중 덮개를 열면 자동으로 정지됩니다. 긴급 상황 시 버튼 하나로 즉시 전원을 차단할 수 있어 가정과 학교 사용에 적합합니다.',
                image: require('@/assets/product/laser/blue530-2.png'),
              },
              {
                icon: require('@/assets/product/laser/tags1.png'),
                title: '다양한 소재 가공 지원',
                bgColor: '#34A853',
                description:
                  '원통형 물체(컵 등) 가공을 위한 액세서리 추가로 다양한 형태와 스타일의 맞춤 제작이 가능하며, 100종 이상의 소재를 지원합니다.',
                image: require('@/assets/product/laser/blue530-3.png'),
              },
            ],
          },
          {
            key: 'markm20',
            label: 'Mark M20',
            images: [
              require('@/assets/product/laser/m20.png'),
              require('@/assets/product/laser/m20.png'),
              require('@/assets/product/laser/m20.png'),
              require('@/assets/product/laser/m20.png'),
              require('@/assets/product/laser/m20.png'),
            ],
            advantages: [
              {
                icon: require('@/assets/product/laser/tags1.png'),
                title: '다양한 적용 시나리오',
                bgColor: '#4285F4',
                description:
                  '보석 조각, 맞춤형 제품, 부품 식별 등 다양한 산업 분야에 적용 가능하며, 소형 산업용 표지판까지 폭넓은 맞춤 조각이 가능합니다.',
                image: require('@/assets/product/laser/m20.png'),
              },
              {
                icon: require('@/assets/product/laser/tags1.png'),
                title: '교육 분야의 혁신적 활용',
                bgColor: '#FFBC0C',
                description:
                  'Mark M20은 산업용 정밀도를 교육 현장에 도입하여 과학·기술 교육을 위한 만능 어시스턴트 역할을 합니다.',
                image: require('@/assets/product/laser/m20-2.png'),
              },
              {
                icon: require('@/assets/product/laser/tags1.png'),
                title: '콤팩트하고 현대적인 디자인',
                bgColor: '#34A853',
                description:
                  '작은 설치 면적, 저소음, 넓은 시야창을 갖춘 콤팩트한 설계로, 높은 내구성과 안전 기준을 충족합니다.',
                image: require('@/assets/product/laser/m20-3.png'),
              },
              {
                icon: require('@/assets/product/laser/tags1.png'),
                title: '몇 초 만에 마킹 완료',
                bgColor: '#0F9D58',
                description:
                  '가장 작은 글꼴도 몇 초 만에 정밀 마킹이 가능하며, LightMaker 소프트웨어와 결합되어 작업 흐름과 생산성이 크게 향상됩니다.',
                image: require('@/assets/product/laser/m20-4.png'),
              },
            ],
          },
          {
            key: 'accessories',
            label: '액세서리',
            images: [
              require('@/assets/product/laser/peijian.png'),
              require('@/assets/product/laser/peijian.png'),
              require('@/assets/product/laser/peijian.png'),
              require('@/assets/product/laser/peijian.png'),
              require('@/assets/product/laser/peijian.png'),
            ],
            advantages: [
              {
                description: `
· 적용 장소: 연기, 악취, 분진, 유해 가스가 발생하는 모든 장소에 적합.
<br>· 적용 분야: 전자, 장난감, 정밀 금속, 의료 분야.
<br>· 설계 특징: 단·복수 공정 가변형 설계.
<br>· 여과 시스템: 다층 여과 장치 탑재.
<br>· 풍량 조절: 배출 가스량에 따라 무단 조절 가능.
<br>· 정화 효율: 최대 99.97%.
<br>· 공기 배출: 정화된 공기를 실내에 직접 배출 가능.
`,
                image: require('@/assets/product/laser/accessories1.png'),
              },
              {
                description: `· 장비 유형: 레이저 절단/조각기 보조 장치.
<br>· 용도: 공작물 회전 구현.
<br>· 적용 대상: 원통형, 관형 물체 등.
<br>· 기능 확장: 평면 가공에서 원통형 가공까지 확장.`,
                image: require('@/assets/product/laser/accessories2.png'),
              },
              {
                description: `
· 고효율 성형기, 정밀 성형 가공 제공.
<br>· CNC 시스템 제어, 조작 간편.
<br>· 다양한 성형 금형 선택 가능.
<br>· 고속 클램핑 시스템으로 작업 효율 향상.
<br>· 완비된 안전 보호 장치.
<br>· 다양한 소재 성형 가공에 적합.
`,
                image: require('@/assets/product/laser/accessories3.png'),
              },
            ],
          },
        ],
      },
    },
    support: {
      afterSales: {
        banner: {
          alt: '튜토리얼 다운로드 배너',
          title: '튜토리얼 다운로드',
          image: require('@/assets/after/banner.png'),
        },
        downloadText: '튜토리얼 다운로드',
        items: [
          {
            id: 'mk-1',
            name: '스마트 농장',
            image: 'https://picsum.photos/seed/as-farm1/588/391',
            link: '#',
          },
          {
            id: 'mk-2',
            name: '스마트 홈',
            image: 'https://picsum.photos/seed/as-home1/588/391',
            link: '#',
          },
          {
            id: 'mk-3',
            name: '스마트 교통',
            image: 'https://picsum.photos/seed/as-traffic1/588/391',
            link: '#',
          },
          {
            id: 'mk-4',
            name: '스마트 공장',
            image: 'https://picsum.photos/seed/as-factory1/588/391',
            link: '#',
          },
          {
            id: 'mk-5',
            name: '메이커 스페이스',
            image: 'https://picsum.photos/seed/as-makerspace1/588/391',
            link: '#',
          },
          {
            id: 'mk-6',
            name: '로봇 과정',
            image: 'https://picsum.photos/seed/as-robot1/588/391',
            link: '#',
          },
          {
            id: 'mk-7',
            name: 'AI 튜토리얼',
            image: 'https://picsum.photos/seed/as-ai1/588/391',
            link: '#',
          },
          {
            id: 'mk-8',
            name: 'IoT 튜토리얼',
            image: 'https://picsum.photos/seed/as-iot1/588/391',
            link: '#',
          },
        ],
      },
    },
  },
};
